export default function Map(){

    document.addEventListener('facetwp-loaded', function() {


        $(document).on('click', '.location-map-item', function(e) {
            e.preventDefault();
            $(this).addClass('is-active');
            $(this).siblings().removeClass('is-active');
            var postid = $(this).attr('data-id');
            var marker = FWP_MAP.get_post_markers(postid);

            $.each( marker, function( key, value ) {

                google.maps.event.trigger(value, 'click');

                FWP_MAP.map.setCenter({
                    lat: value.position.lat(),
                    lng: value.position.lng()
                });

                const mapContainer = document.querySelector('.map-container');
                if(mapContainer) {
                    const elementPosition = mapContainer.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset;

                    window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                    });
                }

            });

        });

    });

}
